export default __webpack_public_path__ + "static/media/logo.74c85c03.png";